import type { HTMLAttributes } from 'react';

import type { IconSvgObject } from '@tmh-website/shared/cms';

interface IconProps extends HTMLAttributes<SVGElement> {
  icon: IconSvgObject;
  size?: number;
}

/**
 * Render custom icons and commonly used icons instantly and reqeust others from the server
 */
export const Icon = ({ icon, size, ...props }: IconProps) => {
  if (!icon) return null;

  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      {...icon.attributes}
      {...props}
      dangerouslySetInnerHTML={{ __html: icon.children ?? '' }}
    />
  );
};

export default Icon;
